import { Icon, Tooltip } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { statusIconMap } from '@pages/notification-components/components/StatusIcon/utils/statusIconMapper';

export interface StatusIconProps {
    id: string;
    status: ComponentCreateRequestStatusCode;
    customTooltipPosition?: boolean;
}

export function StatusIcon(params: StatusIconProps): ReactNode {
    const { status, id: paramsId, customTooltipPosition } = params;

    if (!Object.values(ComponentCreateRequestStatusCode).includes(status)) {
        return;
    }

    const { icon, colorClass, tooltip } = statusIconMap[status];
    const id = !customTooltipPosition ? `status-icon-${paramsId}` : paramsId;

    return (
        <div className="flex h-full align-items-center">
            <Tooltip target={`#${id}`} content={tooltip} position="top" />
            <Icon
                id={!customTooltipPosition ? id : ''}
                className={colorClass}
                name={icon}
            />
        </div>
    );
}
